import { defineStore } from 'pinia';
import { useCmsProxy } from '~dsc/composables/useCmsProxy';
import { ref, computed, useNuxtApp } from '#imports';

export const useLayoutStore = defineStore('layout', () => {
    const layoutData = ref({});
    const isMobileOpen = ref(false);
    const { $paths } = useNuxtApp();
    const logo = ref({
        data: '/images/logo.svg',
        alt: 'Main Logo',
    });

    const navigationTree = computed(() => {
        const parse = item => (item.visibleInNavigation !== false ? {
            id: item.id,
            url: item.url,
            image: item.image,
            text: item.text,
            children: item.children.map(child => parse(child)).filter(v => v),
        } : null);

        return layoutData.value.navigation.map(item => (parse(item))).filter(v => v);
    });

    async function layoutLoad() {
        try {
            const loadedData = await useCmsProxy($paths.getEndpoint('layout'));
            layoutData.value = loadedData;

            if (loadedData.logo) {
                const { 0: logo } = loadedData.logo;
                logo.value = logo;
            }

            return true;
        } catch (e) {
            return false;
        }
    }

    return {
        logo,
        isMobileOpen,
        layoutData,
        navigationTree,
        layoutLoad,
    };
});
